import { Home, NewStory, Story, MyBookmarks, MyStory, PreviosStory, Admin, Chats, Terms, Privacy, StoryAdmin, ReactionStory } from 'pages'

export const userAuthRoutes = [
  {
    path: '/',
    component: Home,
    exact: true,
  },
  {
    path: '/sign-up/first-session',
    component: Home,
    exact: true,
  },
  {
    path: '/reaction/:reaction/:reactionId/:idPodcast',
    component: ReactionStory,
    exact: false,
  },

  {
    path: '/podcast/:id',
    component: Home,
    exact: true,
  },
  {
    path: '/auth/google/redirect',
    component: Home,
    exact: true,
  },
  {
    path: '/register/google/redirect',
    component: Home,
    exact: true,
  },
  {
    path: '/troubled',
    component: Home,
    exact: true,
  },
  {
    path: '/empowered',
    component: Home,
    exact: true,
  },
  {
    path: '/unsubscribeFull',
    component: Home,
    exact: true,
  },
  {
    path: '/unsubscribe',
    component: Home,
    exact: true,
  },
  {
    path: '/new-story/step/:step',
    component: NewStory,
    exact: true,
  },
  {
    path: '/story/:storyId',
    component: Story,
    exact: true,
  },
  {
    path: '/story/:storyId/:newStory',
    component: Story,
    exact: true,
  },
  {
    path: '/storyPrevios/:idUser/:idStory',
    component: PreviosStory,
    exact: true,
  },
  {
    path: '/storyPrevios',
    component: PreviosStory,
    exact: true,
  },
  {
    path: '/new-story/:category/step/:step',
    component: NewStory,
    exact: true,
  },
  {
    path: '/myStory',
    component: MyStory,
    exact: true,
  },
  {
    path: '/myBookmarks',
    component: MyBookmarks,
    exact: true,
  },
  {
    path: '/chat/:category',
    component: Chats,
    exact: true,
  },
  {
    path: '/chat/:category/:chatId',
    component: Chats,
    exact: true,
  },
  {
    path: '/chat/:category/:chatId/review',
    component: Chats,
    exact: true,
  },
  {
    path: '/terms',
    component: Terms,
    exact: true,
  },
  {
    path: '/privacy',
    component: Privacy,
    exact: true,
  },
]

export const userRoutes = [
  {
    path: '/',
    component: Home,
    exact: true,
  },
  {
    path: '/sign-up/first-session',
    component: Home,
    exact: true,
  },
  {
    path: '/reaction/:reaction/:reactionId/:idPodcast',
    component: ReactionStory,
    exact: false,
  },
  {
    path: '/podcast/:id',
    component: Home,
    exact: true,
  },
  {
    path: '/auth/google/redirect',
    component: Home,
    exact: true,
  },
  {
    path: '/register/google/redirect',
    component: Home,
    exact: true,
  },
  {
    path: '/troubled',
    component: Home,
    exact: true,
  },
  {
    path: '/empowered',
    component: Home,
    exact: true,
  },
  {
    path: '/new-story/step/:step',
    component: NewStory,
    exact: true,
  },
  {
    path: '/story/:storyId',
    component: Story,
    exact: true,
  },
  {
    path: '/story/:storyId/:newStory',
    component: Story,
    exact: true,
  },
  {
    path: '/storyPrevios/:idUser/:idStory',
    component: PreviosStory,
    exact: true,
  },
  {
    path: '/storyPrevios',
    component: PreviosStory,
    exact: true,
  },
  {
    path: '/new-story/:category/step/:step',
    component: NewStory,
    exact: true,
  },
  {
    path: '/myStory',
    component: MyStory,
    exact: true,
  },
  {
    path: '/terms',
    component: Terms,
    exact: true,
  },
  {
    path: '/privacy',
    component: Privacy,
    exact: true,
  },
]

export const adminRoutes = [
  {
    path: '/admin/:categoryPage',
    component: Admin,
    exact: true,
  },
  {
    path: '/admin/story/:idStory',
    component: StoryAdmin,
    exact: true,
  },
]
